import React, { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";
import { LOCALSTORAGE, NAVIGATION } from "../Config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserGroup } from "@fortawesome/free-solid-svg-icons";
import { handleSendFriendRequest } from './AddFriends.jsx';
import { BettingOptions } from "../Data";
import VIPModal from "../Components/modals/vip";
import { checkAndUpdateTokens } from '../Data/betdata/CheckAndUpdateTokens.jsx';
import { useTheme } from '../Components/theme/ThemeContext.jsx'; // Import the useTheme hook
import DropdownSelect from '../Components/DropdownSelect.jsx';
import { normalizeAvatarSrc } from "../Components/avatarUtils";
import { getFriends } from '../Data/FriendshipHelpers.jsx';
import formatGameTime from "../Data/formatGameTime";

const createTeamLogoFallback = (teamName, accent) => {
  const label = (teamName || "Team").slice(0, 3).toUpperCase();
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160"><rect width="160" height="160" rx="18" fill="${accent}"/><text x="80" y="94" fill="white" font-family="Arial" font-size="42" font-weight="700" text-anchor="middle">${label}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};


const BetPage = () => {
  const { theme } = useTheme(); // Get the current theme from ThemeContext
  const gameInfo = localStorage.getItem(LOCALSTORAGE.SELECTEDGAME);
  const selectedGame = JSON.parse(gameInfo);

  const navigate = useNavigate();
  const [selectedFriend, setSelectedFriend] = useState(null);
  const [usersFriendList, setUsersFriendList] = useState([]);
  const [selectedBets, setSelectedBets] = useState({});
  const [wager, setWager] = useState("");
  const [email, setEmail] = useState("");
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [showvip, setShowvip] = useState(false);
  const [popup, setPopup] = useState({ show: false, title: "", message: "", onConfirm: null });
  const [friendAvatarById, setFriendAvatarById] = useState({});

  const showPopup = (title, message, onConfirm = null) => {
  setPopup({ show: true, title, message, onConfirm });
};

    const fetchLoggedInUser = async () => {
      const { data: sessionData, error: sessionError } =
        await supabase.auth.getSession();

      if (sessionError) {
        console.error("Error fetching session:", sessionError);
        return;
      }

      if (sessionData && sessionData.session) {
        const user = sessionData.session.user;
        const { data: userData, error: userError } = await supabase
          .from("users")
          .select("*")
          .eq("public_user_id", user.id)
          .single();

        if (userError) {
          console.error("Error fetching user data:", userError);
          return;
        }

        if (userData.has_donated && userData.donateDate) {
          const lastDonationDate = new Date(userData.donateDate);
          const currentDate = new Date();
          const timeDiff = currentDate - lastDonationDate;
          const daysDiff = timeDiff / (1000 * 60 * 60 * 24);

          if (daysDiff > 30) {
         
            const { error: updateError } = await supabase
              .from("users")
              .update({ has_donated: false })
              .eq("public_user_id", user.id);

            if (updateError) {
              console.error("Error updating donation status:", updateError);
            } else {
              console.log("User's donation status updated to false.");
              userData.has_donated = false;
            }
          }
        }

        const updatedUser = await checkAndUpdateTokens(userData);
        setLoggedInUser(updatedUser);
        
        // Load friends from friendships table
        const friendsList = await getFriends(updatedUser.public_user_id);
        setUsersFriendList(friendsList);
      }
    };
  useEffect(() => {

    fetchLoggedInUser();
  }, []);

  useEffect(() => {
    const hydrateFriendAvatars = async () => {
      const friendIds = (usersFriendList || [])
        .map((friend) => friend.public_user_id)
        .filter(Boolean);

      if (!friendIds.length) {
        setFriendAvatarById({});
        return;
      }

      const { data, error } = await supabase
        .from("users")
        .select("public_user_id, avatar")
        .in("public_user_id", friendIds);

      if (error) {
        console.error("Error fetching friend avatars:", error);
        return;
      }

      const avatarMap = (data || []).reduce((acc, row) => {
        const normalized = normalizeAvatarSrc(row.avatar);
        if (normalized) {
          acc[row.public_user_id] = normalized;
        }
        return acc;
      }, {});

      setFriendAvatarById(avatarMap);
    };

    hydrateFriendAvatars();
  }, [usersFriendList]);

  const onSuccess = () => {
    setEmail("");
  };

const updateCheckedBets = (betOption) => {
  if (!betOption) {
    setSelectedBets({}); // fully clears all selected bets
  } else {
    setSelectedBets({ [betOption]: true }); // ensures only one bet active
  }
};

  const placeBet = async () => {
    if (!selectedFriend) {
      alert("Please select a friend to bet with.");
      return;
    }

    if (!loggedInUser) {
      alert("User not logged in.");
      return;
    }
    if (!loggedInUser.has_donated && !loggedInUser.is_admin) {
      let betTokens = loggedInUser.betToken || 0;

      if (betTokens <= 0) {
        setShowvip(true);
        return;
      }

      betTokens -= 1;

      const { error: tokenError } = await supabase
        .from("users")
        .update({ betToken: betTokens })
        .eq("public_user_id", loggedInUser.public_user_id);

      if (tokenError) {
        console.error("Error updating bet tokens:", tokenError);
        alert("An error occurred while placing your bet. Please try again.");
        return;
      }

      // Update the token count in the frontend state
      setLoggedInUser({ ...loggedInUser, betToken: betTokens });
    }

    const newBet = {
      betid: new Date().getTime().toString(),
      gameid: selectedGame.game_ID,
      gametitle: selectedGame.gameTitle,
      homelogo: selectedGame.homeLogo || createTeamLogoFallback(selectedGame.homeTeam, "#1f7a4a"),
      awaylogo: selectedGame.awayLogo || createTeamLogoFallback(selectedGame.awayTeam, "#1f4f9a"),
      betdescription: selectedBets,
      betcreator: loggedInUser.username,
      creator_id: loggedInUser.public_user_id,
      wager: wager,
      result: "Waiting",
      friends: selectedFriend.username,
      friend_id: selectedFriend.public_user_id,
      betstatus: "pending",
      sporttype: selectedGame.sportType,
    };

    const { error } = await supabase.from("bets").insert([newBet]);
    if (error) {
      console.error("Error placing bet:", error);
      alert("There was an error placing your bet. Please try again.");
      return;
    }

    const { error: smsError } = await supabase.functions.invoke("send-bet-sms", {
      body: { betId: newBet.betid },
    });
    if (smsError) {
      console.error("Error sending bet SMS:", smsError);
    }

    try {
      const response = await fetch(
        "https://friendly-bets-back-end.vercel.app/api/newbet",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            toUserEmail: selectedFriend.email, // Use selected friend's email
          }),
        }
      );

      if (response.ok) {
        alert("Bet placed and notification sent successfully");
      } else {
        console.warn("Email notification endpoint returned", response.status);
      }
    } catch (error) {
      // The backend may send the email before its response is blocked by CORS.
      console.warn("Email notification was sent, but its response could not be read:", error);
    }
    navigate(NAVIGATION.MYBETS);
  };

  const cardStyles = {
    light: {
      backgroundColor: "#ffffff",
      color: "#000000",
      border: "1px solid #ddd",
    },
    dark: {
      backgroundColor: "#1e1e1e",
      color: "#ffffff",
      border: "1px solid #444",
    },
    retro: {
      backgroundColor: "#f4e2d8",
      color: "#2b2b2b",
      fontFamily: "Courier New, Courier, monospace",
      border: "2px solid #ff9900",
    },
  };

  const friendOptions = usersFriendList.map((friend) => ({
    value: friend.public_user_id,
    label: friend.username,
    avatarSrc:
      friendAvatarById[friend.public_user_id] ||
      normalizeAvatarSrc(friend.avatar) ||
      "",
  }));

  return (
    <div
      className={`container mt-2 text-center p-2 rounded ${theme}`}
    >
      <div>      <VIPModal show={showvip} onClose={() => setShowvip(false)} onDonationSuccess={async()=>{
        await fetchLoggedInUser();
      }} /></div>

      <div className="set-bet-div text-center">
        <span className="straight-line"></span>
        <p className="set-bet-text">Set Your Bet</p>
        <span className="straight-line"></span>
      </div>
      <div className="card-body" style={cardStyles[theme]}> {/* Apply inline styles */}
        <h5 className="card-title text-center text-info">
          {selectedGame.gameTitle}
        </h5>
        <p className="text-center text-info">
          {formatGameTime(selectedGame.gameTime)}
        </p>
        <div className="row">
          <div className="col d-flex justify-content-center align-items-center">
            <img
              src={selectedGame.awayLogo}
              alt="away logo"
              className="img-fluid"
              style={{ width: "100px", height: "100px" }}
            />
          </div>
          <div className="col d-flex justify-content-center align-items-center">
            <span className="vs-text">VS</span>
          </div>
          <div className="col d-flex justify-content-center align-items-center">
            <img
              src={selectedGame.homeLogo}
              alt="home logo"
              className="img-fluid"
              style={{ width: "100px", height: "100px" }}
            />
          </div>
        </div>

        {usersFriendList.length >= 1 ? (
          <p className="friends-number">
            <FontAwesomeIcon icon={faUserGroup} /> {usersFriendList.length}
          </p>
        ) : (
          <div className="mb-3 mt-3 w-50 mx-auto d-flex align-items-center">
            <input
              style={{ backgroundColor: "#f2f2f2", borderColor: "gray" }}
              type="email"
              className="form-control me-1 custom-input"
              placeholder="AddFriend@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              style={{ height: "3rem", width: "6rem" }}
              className="btn btn-outline-info ms-2"
              onClick={() => handleSendFriendRequest(email, onSuccess,showPopup)}
              type="button"
            >
              Send
            </button>
          </div>
        )}

        <div className="mb-3">
          <DropdownSelect
            className="w-100"
            options={friendOptions}
            value={selectedFriend ? selectedFriend.public_user_id : ""}
            placeholder="Select a Friend"
            showAvatars={true}
            onChange={(friendId) => {
              const friend = usersFriendList.find(
                (item) => item.public_user_id === friendId
              );
              setSelectedFriend(friend || null);
            }}
          />
        </div>
        <input
          style={{ backgroundColor: "#f2f2f2", borderColor: "gray" }}
          className="mb-3 custom-input w-50 text-center"
          type="text"
          placeholder="Type Your Wager"
          onChange={(event) => setWager(event.target.value)}
        ></input>
        <>
          <BettingOptions
            game_ID={selectedGame}
            updateCheckedBets={updateCheckedBets}
            selectedBets={selectedBets}
          />
        </>
        <button className="btn custom-button mx-1" onClick={placeBet}>
          Place Bet
        </button>
        <button
          className="btn custom-button"
          onClick={() => navigate("/MyBets")}
        >
          Check Bets
        </button>
      </div>
    </div>
  );
};

export { BetPage };